import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Segment, Dimmer, Loader, Modal } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import {
    requestCreateEvent
    // @ts-ignore
} from 'services/events/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Workspaces
import {
    makeSelectQueryStringNumberValue,
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import EventRequest from '../EventRequest';
// @ts-ignore
import GeneralEventForm from '../GeneralEventForm';

interface StateProps {
    id?: number;
    isOpen?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
    requestCreateEvent: Function;
}

type IProps = StateProps & DispatchProps;

export class GeneralEventDuplicateModal extends React.PureComponent<IProps> {
    handleClose = () => {
        this.props.updateQueryString({
            generalEventDuplicateModal: undefined,
            selectedEvent: undefined,
            selectedCurrentEntityId: undefined,
            newGroup: undefined
        });
    };

    handleSubmit = (values: any) => {
        this.props.requestCreateEvent(values);
    };

    render(): React.ReactElement | null {
        const { id, isOpen } = this.props;

        if (!id) {
            return null;
        }

        return (
            <Modal
                size="fullscreen"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="GeneralEventDuplicateModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <React.Fragment>
                        <EventRequest eventId={id} />
                        <ErrorGate namespace="EVENT_LOAD">
                            <LoadingGate
                                namespace="EVENT_LOAD"
                                LoadingComponent={
                                    <Segment basic padded="very">
                                        <Dimmer active inverted>
                                            <Loader inverted />
                                        </Dimmer>
                                    </Segment>
                                }
                            >
                                <GeneralEventForm
                                    eventId={id}
                                    onClose={this.handleClose}
                                    onSubmit={this.handleSubmit}
                                />
                            </LoadingGate>
                        </ErrorGate>
                    </React.Fragment>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    id: makeSelectQueryStringNumberValue('selectedEvent'),
    isOpen: makeSelectQueryStringBooleanValue('generalEventDuplicateModal')
});

export default connect<StateProps, DispatchProps, {}>(mapStateToProps, {
    updateQueryString,
    requestCreateEvent
})(GeneralEventDuplicateModal);
